//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { syncLogFindList } from '@/api/PMS/baseInformation/customer';
import waves from '@/directive/waves'; // 水波纹指令
// 导入

export default {
  props: ['keyValue', 'showDialog', 'houseId'],
  components: {},
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      searchId: [],
      listQuery: {
        page: 1,
        limit: 10,
        isLimit: '0',
        customerId: null
      },
      multipleSelection: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.getList();
      }
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.customerId = this.keyValue;
      syncLogFindList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    showFunctionType: function showFunctionType(data) {
      if (data === 7) {
        return '下发用户信息';
      } else if (data === 8) {
        return '下发人脸信息';
      }
    },
    showOperateType: function showOperateType(data) {
      if (data === 1) {
        return '用户新增';
      } else if (data === 2) {
        return '用户删除';
      } else if (data === 3) {
        return '人脸新增';
      } else if (data === 4) {
        return '人脸删除';
      }
    },
    showIsSync: function showIsSync(data) {
      if (data === 1) {
        return '未同步';
      } else if (data === 2) {
        return '成功';
      } else if (data === 3) {
        return '失败';
      }
    }
  }
};